import gsap from "gsap";

function animDropDown(open, activeSettingId, dropDown, riseUp){
    // gsap.to(".dropDownChoices", {height: 0, duration: 0});
    // gsap.to(".dropDownField", {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
    let yOffset = 0;

    if (open) {
        // console.log(open, activeSettingId, dropDown)
      let activeSettingIdVal;
      if (!activeSettingId) {
        activeSettingIdVal = 'new';
      } else {
        activeSettingIdVal = activeSettingId;
      }
      // console.log('dropDown', dropDown, 'settingsRow_' + dropDown, document.getElementById('settingsRow_' + dropDown), activeSettingIdVal)
      let parent = document.getElementById('settingsRow_' + dropDown).offsetLeft;
      let dropDownElem;
      dropDownElem = document.getElementById("inputField_" + dropDown + "_" + activeSettingIdVal ).offsetLeft;
      let offsetLeft = parent - dropDownElem;

      if (riseUp) {
        yOffset = '-150px'
      }
      var tl = gsap.timeline();
      tl.to("#inputField_" + dropDown + "_" + activeSettingIdVal + " .dropDownChoices", {height: "auto", y: yOffset, duration: 0});
      tl.to("#inputField_" + dropDown + "_" + activeSettingIdVal, {zIndex: 3, x: offsetLeft, height: "auto", duration: 0}, "<");
      tl.to("#inputField_" + dropDown + "_" + activeSettingIdVal, {scale: 1, opacity: 1, duration: 0.1});
      // console.log('yOffset', yOffset)
    } else {
      gsap.to(".dropDownChoices", {height: 0, y: 0, duration: 0});
      gsap.to(".dropDownField", {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
    }
  }
  function processCSS(objCss, zoomRatio, opacity) {
    let array = Object.entries(objCss);
    let reactCss = {};

    // console.log('objcss', objCss)

    array.forEach((obj, i) => {
      switch (obj[0]) {
        case 'font-family':
          reactCss['fontFamily'] = obj[1];
          break;
        case 'font-weight':
          reactCss['fontWeight'] = obj[1];
          break;
        case 'font-size':
          let s = obj[1];
     
          if (s) {
            if (typeof s === 'string') {
              let s0 = s.replace('px', '');
              // let s = parseInt(s0);
              s = parseInt(s0) * parseFloat(zoomRatio.toFixed(2));
              // console.log('s 1', s)
            } else {
              // s = parseInt(s)
              s = parseInt(s) * zoomRatio;
              // console.log('s 2', s)
            }
           
            // console.log('s', parseInt(s), parseFloat(zoomRatio.toFixed(2)))
            reactCss['fontSize'] = s + "px";
          }
           
          break;
        case 'text-align':
          reactCss['textAlign'] = obj[1];
          break;
        case 'color':
          reactCss['color'] = obj[1];
          break;
        case 'letter-spacing':
          reactCss['letterSpacing'] = obj[1];
          break;
        case 'line-height':
          reactCss['lineHeight'] = obj[1];
          break;
        default:
          break;
      }
    })
    // This translate math is probably wrong for all situations
    // reactCss['transform'] = 'scale(0.59) translate(-35%, -25%)'

    // if (callback) {
    //   setTimeout(() => {
    //     callback();
    //   }, 200);
    // }
    reactCss['opacity'] = opacity/100  

    return reactCss
  }



  function restoreSelection(ranges){

      const selection = window.getSelection();
      selection.removeAllRanges();
      ranges.forEach((range) => {
        selection.addRange(range)
      })
      console.log("restoreSelection",  ranges)

  }


  function replaceCharacter(origString, index, replaceChar) {
    let firstPart = origString.substr(0, index);
    let lastPart = origString.substr(index + 1);
    let newString = firstPart + replaceChar + lastPart;
    return newString;
  }


  function processHtmlText(textObj, zoomRatio, elemId, tempText) {
    let span = document.createElement('span');
    span.innerHTML = "";
    let charOverrides = textObj['charStyleOverrides'];
    let styleOverrides = textObj['styleOverrides'];
    let result;


    let newText = '';
    
    if (textObj['text'] === "") {
      if (elemId) {
        let elem = document.getElementById(elemId);
        if (elem) {
          newText = structuredClone(elem.textContent);
        }
        // console.log('using element text', newText)
      }
      
    } else {
      newText = structuredClone(textObj['text']);
     } 


    //  if (newText) {
    //   newText.replace(/<br>/g, '\n');
    //  }
     

    // console.log('processHtmlText start', textObj, newText)

    if (charOverrides && charOverrides.length > 0) {     
      let tempSpan = "";
      for (let i = 0; i < newText.length; i++) {

        if (charOverrides[i] && (charOverrides[i] !== 0)) {
          if (charOverrides[i - 1] && (charOverrides[i - 1] === charOverrides[i])) {
              // let ws = /\s/.test(newText.charAt(i));
              tempSpan+=newText.charAt(i)

              if (i === charOverrides.length - 1) {
                tempSpan+="</span>";
              }
        
          } else {
            let style = styleOverrides.find(a => a.id === charOverrides[i])
            let fontSize = null;
            if (style) {
              const styleString = (
                Object.entries(style['css']).map(([k, v]) => 
                  {
                    if (k === "font-size"){
                      let value = `${v}`;
                      let s0 = value.replace('px', '');
                      // let s = parseInt(s0);
                      fontSize = s0;
                 
                      let s = parseInt(s0) * zoomRatio;
                      let sVal = s.toFixed(2)  + "px"
                      return `${k}:${sVal}`
                  } else {
                    return `${k}:${v}`
                  }
                }
                    
              ).join(';')
              );

              if ((charOverrides[i - 1] && (charOverrides[i - 1] !== charOverrides[i]))) {
                tempSpan+="</span>";
              }

              tempSpan+="<span style='" + styleString + "' data-fontsize=" + fontSize + ">" + newText.charAt(i);
              if (i === charOverrides.length - 1) {
                tempSpan+="</span>";
              }
          
            }
        
          }   

        } else {
          tempSpan+=newText.charAt(i)

          if ((charOverrides[i - 1] && (charOverrides[i - 1] !== charOverrides[i]))) {
            tempSpan+="</span>";
          }
          
        }
        
      }


      
      result = tempSpan;
      // console.log('processHtmlText result', span0)
    } else {
      result = textObj['text'];
    }
    return result;
  }

  function handleInputDropDownFocus(target){

    function runDropDown() {
      var dropdown_id = target.id;
      var dropdown = document.getElementById(dropdown_id + '_dd');
      if (target.classList.contains('on')) {
        target.classList.remove('on');
        if (dropdown) {
          dropdown.classList.add('off');
        }
      } else {
        var onInputs = document.querySelectorAll('.valueInput.on');
        var onDropDowns = document.querySelectorAll('.inputDropDown');
        var i;
        for (i = 0; i < onInputs.length; i++) {
          onInputs[i].classList.remove('on');
        }
        var j;
        for (j = 0; j < onDropDowns.length; j++) {
          onDropDowns[j].classList.add('off');
        }
        
        target.classList.add('on');
        if (dropdown) {
          dropdown.classList.remove('off');
        }
        
      }
    }
    runDropDown()
   
   
  }


  function handleInputFocus(e){
    var target = e.target;
    function runInput(){
      
      var existingVal = target.value;
  
      if (!existingVal) {
        var val = target.placeholder;
        target.value = val;
      }
    }

   
    // console.log('handleInputFocus', target, val, e)

    runInput();
    // restoreSelection(ranges)
    // target.select();
    
    handleInputDropDownFocus(target);

   
    
 
  }

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  function rgbToHex(rgb) {
    // Choose correct separator
    let sep = rgb.indexOf(",") > -1 ? "," : " ";
    // Turn "rgb(r,g,b)" into [r,g,b]
    rgb = rgb.substr(4).split(")")[0].split(sep);
  
    let r = (+rgb[0]).toString(16),
        g = (+rgb[1]).toString(16),
        b = (+rgb[2]).toString(16);
  
    if (r.length === 1)
      r = "0" + r;
    if (g.length === 1)
      g = "0" + g;
    if (b.length === 1)
      b = "0" + b;
  
    return "#" + r + g + b;
  }

  

export {
    animDropDown,
    processCSS,
    handleInputFocus,
    processHtmlText,
    hexToRgb,
    rgbToHex,
    restoreSelection
    }